import React, { useState } from 'react'
import { Button, Typography, message } from 'antd'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import { OrganisationNav } from './OrganisationNav'

interface OrganisationLayoutProps {
  orgaId: string
  orgaName: string
  children: React.ReactNode
}

function isParamsTab(pathname: string, base: string) {
  return pathname === base || pathname === `${base}/` || pathname === `${base}/params`
}

export function OrganisationLayout({ orgaId, orgaName, children }: OrganisationLayoutProps) {
  const location = useLocation()
  const base = `/organisations/${orgaId}`
  const showDelete = isParamsTab(location.pathname, base)
  const [deleting, setDeleting] = useState(false)

  const onDelete = async () => {
    if (!window.confirm('Etes-vous certain de supprimer cette organisation ?')) {
      return
    }

    setDeleting(true)
    try {
      await axios.delete(`/organisations/${orgaId}`)
      message.success('Organisation supprimée')
      window.location.href = '/organisations'
    } catch (error) {
      console.error(error)
      message.error("Impossible de supprimer l'organisation")
      setDeleting(false)
    }
  }

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 8 }}>
        <Typography.Title level={2} style={{ margin: 0 }}>
          {orgaName}
        </Typography.Title>
        {showDelete && (
          <Button danger loading={deleting} onClick={onDelete}>
            Supprimer l'organisation
          </Button>
        )}
      </div>
      <OrganisationNav orgaId={orgaId} />
      {children}
    </>
  )
}
